import script from "./PWAInstallButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./PWAInstallButton.vue?vue&type=script&lang=ts&setup=true"

import "./PWAInstallButton.vue?vue&type=style&index=0&id=afb67a80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afb67a80"]])

export default __exports__